import { NAME_SPACES } from "shared/locales/constants";
import contact from "./contact";

const translations = { [NAME_SPACES.PUBLIC.CONTACT]: contact };

export default translations;
